import { Container } from "basis";
import { EnhancedAccount } from "library/accounts/types";
import { AccountHeader } from "../../ManagePersonalDetails/components/AccountHeader";
import { accountHelpers } from "../utils";
import { ExceptionContent } from "./ExceptionContent";
import { JointAccountContent } from "./JointAccountContent";
import { PaymentNotification } from "./PaymentNotification";
import { PersonalLoanContent } from "./PersonalLoanContent";

type Props = {
  account: EnhancedAccount;
};

export const AccountCard = ({ account }: Props) => {
  const { accountCardTestId, isPersonalLoan, hasNoToken, isJointAccount } =
    accountHelpers(account);

  const AccountCardTemplate = () => {
    if (isPersonalLoan) {
      return <PersonalLoanContent />;
    }
    if (isJointAccount) {
      return <JointAccountContent />;
    }
    // Credit card with an exception - no token
    if (hasNoToken) {
      return <ExceptionContent />;
    }
    return (
      <PaymentNotification
        token={account.credit_card?.token!}
        accountId={account.account_id}
      />
    );
  };

  return (
    <Container hasBorder testId={accountCardTestId}>
      <AccountHeader account={account} />
      <Container padding="5">
        <AccountCardTemplate />
      </Container>
    </Container>
  );
};
